/**
 * Extracts the last 4 digits from an IBAN or masked IBAN string.
 * Handles various formats including full IBANs, masked IBANs with asterisks,
 * and pre-sliced 4-digit strings.
 *
 * @param iban - The IBAN string (can be full, masked, or already sliced)
 * @returns The last 4 characters of the IBAN, or empty string if invalid
 *
 * @example
 * getIbanLast4('FR7630006000011234567890189') // returns '0189'
 * getIbanLast4('***********************2606') // returns '2606'
 * getIbanLast4('1234') // returns '1234'
 * getIbanLast4('') // returns ''
 */
export function getIbanLast4(iban: string | null | undefined): string {
  if (!iban) {
    return '';
  }
  return iban.slice(-4);
}

/**
 * Formats an IBAN last 4 digits with a masked prefix for display.
 *
 * @param ibanLast4 - The last 4 digits of an IBAN
 * @returns Masked IBAN string with dots prefix, or empty string if invalid
 *
 * @example
 * formatMaskedIban('1234') // returns '••••••••••••1234'
 * formatMaskedIban('') // returns ''
 */
export function formatMaskedIban(ibanLast4: string | null | undefined): string {
  if (!ibanLast4) {
    return '';
  }
  const last4 = getIbanLast4(ibanLast4);
  return `••••••••••••${last4}`;
}
